module.exports = __webpack_public_path__ + "static/austral bricks logo-e79e26fbf45b2c81dd5afd2498cda8fe.png";